import Vue from 'vue';
import VueRouter from 'vue-router';
import RouterConfig from './modules'; // 引入业务逻辑模块
Vue.use(VueRouter);

export default new VueRouter({
  base: '/',
  mode: 'history', // 去掉url中的#
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: RouterConfig
});



// WEBPACK FOOTER //
// ./src/router/index.js